const adminSettingCustomColorStyle = {
    custom: {
        justifyContent: 'center',
        marginTop: '20px',
    },
    customSite: {
        marginBottom: '20px',
    },
    input: {
        '& input': {
            padding: '6px',

            '&::-webkit-inner-spin-button': {
                opacity: 1, // Always show spin buttons on Chrome
            },
        },
    },
    customTitleSub: {
        marginLeft: '30px',
    },
    customTitle: {
        fontWeight: 'bold',
    },
    customFooter: {
        marginBottom: '20px',
        marginTop: '20px',
    },
    customButton: {
        width: '150px',
    },
    customButtonReset: {
        width: '150px',
        margin: '0 20px',
    },
    customFooterButton: {
        textAlign: 'end',
    },
};

export default adminSettingCustomColorStyle;
